export class ContentFileUpload {
    name: string;
    url: string;
    file: File;
    progress: number;
    constructor(file: File) {
      this.file = file;
    }
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/content-files-upload.ts